import { Badge } from '@@/Badge';

export function SettingItem({
  label,
  value,
}: {
  label: string;
  value: boolean | undefined;
}) {
  return (
    <div className="flex items-center justify-between py-3 px-4 bg-gray-2 th-dark:bg-gray-iron-10 border-b border-gray-5 th-dark:border-gray-7 last:border-b-0">
      <span className="text-sm">{label}</span>
      <Badge type={value ? 'success' : 'muted'}>
        {value ? 'Enabled' : 'Disabled'}
      </Badge>
    </div>
  );
}
